import DrillxToggle from 'components/DrillxToggle';
import { useFavouriteWellsManager } from 'hooks/useFavouriteWellsManager';
import React, { ChangeEvent, memo, useCallback, useState } from 'react';
import { WellFullDetailsWithUniqueKeyDTO } from 'types/well';

interface Prop {
  well: WellFullDetailsWithUniqueKeyDTO;
}

const FavouriteWellSwitch: React.FC<Prop> = ({ well }) => {
  const { isFavourite, addUserFavouriteWell, removeUserFavouriteWell } = useFavouriteWellsManager();
  const [checked, setChecked] = useState(isFavourite(well));

  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      e.target.checked ? addUserFavouriteWell(well) : removeUserFavouriteWell(well);
      setChecked(e.target.checked);
    },
    [addUserFavouriteWell, removeUserFavouriteWell, well],
  );

  return <DrillxToggle onChange={onChange} checked={checked} label={well.unifiedWellName} />;
};

export default memo(FavouriteWellSwitch);
